import { serviceNames, diContainer } from '../../service-setup/diContainer';
import { ProductRepository } from '../repositories/ProductRepository';
import { IItem } from '../../api/ProdcatApiSdk';

export class LoadCrossSellProductsUseCase {
    private productRepository: ProductRepository;
    private uniqueCrossSellSkuIds: IItem[] = [];

    constructor(uniqueCrossSellSkuIds: IItem[]) {
        this.uniqueCrossSellSkuIds = uniqueCrossSellSkuIds;
        this.productRepository = diContainer.get(serviceNames.productRepository);
    }

    public execute = async () => {
        if (this.uniqueCrossSellSkuIds.length > 0) {
            const includeInnerHits = false;
            await this.productRepository.getProductsByIds(
                this.uniqueCrossSellSkuIds,
                includeInnerHits
            );
        }
    };
}
